import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

class ResidentialCanteensApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/residential-canteens'
    }
}

export default new ResidentialCanteensApiClient()
